import { ResultRow } from '../api/ForecastApi';
import { todayString } from './date';

function escapeCell(value: string | number | undefined): string {
  const s = value == null ? '' : String(value);
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

const MAX_IDS_IN_NAME = 3;

// Builds a query-context filename, e.g. freshsight_demand_UFF_NA_100004_2026-07-14.csv.
// IDs are listed when few, otherwise summarised as a count (e.g. 4fgids).
export function buildCsvFileName(parts: {
  viewType: string;
  business: string;
  region: string;
  fgids?: number[];
  siteIds?: string[];
}): string {
  const segments = ['freshsight', parts.viewType, parts.business, parts.region];
  const ids = parts.fgids?.length ? parts.fgids.map(String) : parts.siteIds ?? [];
  const idLabel = parts.fgids?.length ? 'fgids' : 'sites';
  if (ids.length > 0) {
    segments.push(
      ids.length <= MAX_IDS_IN_NAME ? ids.join('_') : `${ids.length}${idLabel}`
    );
  }
  segments.push(todayString());
  return `${segments.join('_')}.csv`;
}

export function toCsv(rows: ResultRow[]): string {
  if (rows.length === 0) return '';
  const columns = Array.from(
    rows.reduce((set, row) => {
      Object.keys(row).forEach((k) => set.add(k));
      return set;
    }, new Set<string>())
  );
  const header = columns.map(escapeCell).join(',');
  const body = rows.map((row) =>
    columns.map((c) => escapeCell(row[c])).join(',')
  );
  return [header, ...body].join('\n');
}
